import { useSelector } from 'react-redux';
import { ErrorIcon } from '../../Pages/BusinessInfo';
import { AlertContainer, IconWrapper, Title, ErrorItem } from './PaymentDeclineAlert';

const PolicyPurchaseErrorAlert = () => {
  const reasonabilityErrors = useSelector((state: ReduxState) => state.reasonabilityErrors || []);

  if (!reasonabilityErrors || reasonabilityErrors.length === 0) return null;

  return (
    <AlertContainer>
      <IconWrapper>
        <ErrorIcon />
      </IconWrapper>
      <Title>
        There was a problem with your application. Please check that the information you entered is correct. If the
        problem persists use the chat button to contact support and tell the errors you received:
      </Title>
      {reasonabilityErrors.map((error, index) => (
        <ErrorItem key={index}>{typeof error === 'string' ? error : error?.message}</ErrorItem>
      ))}
    </AlertContainer>
  );
};
export default PolicyPurchaseErrorAlert;
